import { render, staticRenderFns } from "./BikesView.vue?vue&type=template&id=a2435890&scoped=true&lang=pug&"
import script from "./BikesView.vue?vue&type=script&lang=js&"
export * from "./BikesView.vue?vue&type=script&lang=js&"
import style0 from "./BikesView.vue?vue&type=style&index=0&id=a2435890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2435890",
  null
  
)

export default component.exports